<div class="panel panel-flat">

  <div class="tabbable">
    <ul class="nav nav-tabs nav-tabs-highlight">
      <li class="active"><a href="#award-tab" data-toggle="tab"> <i class="icon-trophy3 position-left"></i>Award
        </a></li>
      <li><a href="#award-detail-tab" data-toggle="tab"> <i class="icon-stats-bars3 position-left"></i>Details
        </a></li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane active" id="award-tab">


        <div class="row" style="padding-left:20px;">
          <div class="col-md-9">

            <!--   <h4 class="custom-title">Qualified Members</h4> -->
            <h6>QUALIFIED MEMBERS</h6>
            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Code</th>
                  <th>Enrolled</th>
                  <th>Membership Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let user of ekubMembers | paginate: { id: 'ekubMembers',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">

                  <!--  <tr> -->
                  <td>
                    <div class="media">
                      <span class="media-left">
                        <img *ngIf="!user.avatar" src="assets/img/userm.png" width="40" height="40"
                          class="img-circle img-md" alt="">
                        <img *ngIf="user.avatar" [src]="baseUrl+'assets/'+user.avatar+'/render'" width="40" height="40"
                          class="img-circle img-md" alt="">
                      </span>
                      <div class="media-left">{{user.username}}
                        <div class="text-muted text-size-small">
                          Joined: {{user?.pivot.created_at|date:short}}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{{user.email}}</td>
                  <td>{{user.phone_number}}</td>
                  <td>{{user?.pivot.code}}</td>
                  <td>{{user?.pivot.created_at|date:short}}</td>
                  <td>
                    <span *ngIf="user.pivot.status === 'Pending' || user.pivot.status === 'pending'"
                      class="label label-block label-warning">{{user.pivot.status}}</span>
                    <span *ngIf="user.pivot.status === 'Won' || user.pivot.status === 'won'"
                      class="label label-block bg-royal-400">{{user.pivot.status}}</span>
                    <span *ngIf="user.pivot.status === 'Initialized' || user.pivot.status === 'initialized'"
                      class="label label-block bg-royal-400"><!-- {{user.pivot.status}} -->won</span>
                    <span *ngIf="user.pivot.status === 'Qualified' || user.pivot.status === 'qualified'"
                      class="label label-block label-success">{{user.pivot.status}}</span>
                    <span *ngIf="user.pivot.status === 'Disqualified' || user.pivot.status === 'disqualified'"
                      class="label label-block label-danger">{{user.pivot.status}}</span>
                    <span *ngIf="user.pivot.status === 'Active' || user.pivot.status === 'active'"
                      class="label label-block label-primary">{{user.pivot.status}}</span>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
          <div class="col-md-3">


            <!-- Secondary sidebar -->
            <div class="sidebar sidebar-secondary sidebar-default pull-right">
              <div class="sidebar-content">

                <!-- Title -->
                <div class="category-title h6">
                  <span class="custom-subtitle">Fail Safe</span>
                  <ul class="icons-list">
                    <li><a href="#"><i class="icon-gear"></i></a></li>
                  </ul>
                </div>
                <!-- /title -->


                <!-- User thumbnail -->
                <div class="thumbnail">
                  <div class="thumb thumb-rounded request-loader text-center" [ngClass]="{'request-load': failSafe}">
                    <button [disabled]="failSafe" type="button" class="btn btn-circle btn-xl"
                      (click)="activateFailSafe()">Start</button>
                  </div>
                  <div class="caption text-center">
                    <h4 class="custom-title text-semibold no-margin">Activate Failsafe</h4>
                  </div>
                </div>
                <!-- /user thumbnail -->


                <!-- Latest updates -->
                <div class="sidebar-category">
                  <div class="category-title">
                    <span>Award Details</span>
                    <ul class="icons-list">
                      <li><a href="javascript:void(0);" data-action="collapse"></a></li>
                    </ul>
                  </div>

                  <div class="category-content">
                    <ul class="media-list">


                      <li class="media">
                        <div class="media-left">
                          <a href="#" class="btn border-info text-info btn-flat btn-rounded btn-icon btn-sm"><i
                              class="icon-cash"></i></a>
                        </div>

                        <div class="media-body">
                          520,000 ETB
                          <div class="media-annotation">Award Value</div>
                        </div>
                      </li>

                      <li class="media">
                        <div class="media-left">
                          <a href="#" class="btn border-success text-success btn-flat btn-rounded btn-icon btn-sm"><i
                              class="icon-user-check"></i></a>
                        </div>

                        <div class="media-body">
                          Qualified Members
                          <div class="media-annotation">48</div>
                        </div>
                      </li>

                      <li class="media">
                        <div class="media-left">
                          <a href="#" class="btn border-danger text-danger btn-flat btn-rounded btn-icon btn-sm"><i
                              class="icon-user-block"></i></a>
                        </div>

                        <div class="media-body">
                          2
                          <div class="media-annotation">Disqualified Members</div>
                        </div>
                      </li>

                      <li class="media">
                        <div class="media-left">
                          <a href="#" class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm"><i
                              class="icon-info22"></i></a>
                        </div>

                        <div class="media-body">
                          {{award?.status}}
                          <div class="media-annotation">Award Status</div>
                        </div>
                      </li>
                      <li class="media">
                        <div class="media-left">
                          <a href="#" class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm"><i
                              class="icon-alarm"></i></a>
                        </div>

                        <div class="media-body">
                          <!--  {{days|number:'1.0-0'}}:{{hours|number:'1.0-0'}}:{{minutes|number:'1.0-0'}}:{{seconds|number:'1.0-0'}} -->
                          <h5 class="">Drawing starting in</h5>
                        </div>

                        <div class="panel-body">

                          <ul class="timer mb-10">
                            <!-- <li>
                                  {{days|number:'1.0-0'}} <span>days</span>
                                </li>
                                <li class="dots">:</li> -->
                            <li>
                              {{hours|number:'1.0-0'}} <span>hours</span>
                            </li>
                            <li class="dots">:</li>
                            <li>
                              {{minutes|number:'1.0-0'}} <span>minutes</span>
                            </li>
                            <li class="dots">:</li>
                            <li>
                              {{seconds|number:'1.0-0'}} <span>seconds</span>
                            </li>
                          </ul>
                        </div>


                      </li>
                    </ul>
                  </div>
                </div>
                <!-- /latest updates -->






              </div>
            </div>
            <!-- /secondary sidebar -->




          </div>

        </div>







      </div>
      <div class="tab-pane" id="award-detail-tab">

        <div class="row" style="padding-left:20px;">
          <div class="col-md-6">





            <div class="row">
              <br>
              <br>
              <div class="">
                <div class="btn-group pull-right">
                  <a data-toggle="modal" data-target="#guarantee_modal" type="button"
                    class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                    <i *ngIf="guarantees?.length == 0" class="icon-add position-left"></i>
                    <i *ngIf="guarantees?.length > 0" class="icon-pencil5 position-left"></i>
                    {{guarantees?.length > 0 ? 'Edit Guarantee':'Add
                    Guarantee'}}</a>

                </div>
                <br>
                <br>
                <table class="table datatable-column-search-inputs">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Ref. Number</th>
                      <th>Amount Guaranteed</th>
                      <th>Guarantee Value</th>
                      <th>Status</th>
                      <th>Remark</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let guarantee of guarantees; let i = index">
                      <td>{{guarantee.type}}</td>
                      <td>{{guarantee.ref_number}}</td>
                      <td>{{guarantee.amount_guaranteed|number:'1.2-2'}} ETB</td>
                      <td>{{guarantee.guarantee_value|number:'1.2-2'}} ETB</td>
                      <td>
                        <span class="label label-block label-default"
                          *ngIf="guarantee.status === 'Pending' || guarantee.status === 'pending'">{{guarantee.status}}</span>
                        <span class="label label-block label-primary"
                          *ngIf="guarantee.status === 'Active' || guarantee.status === 'active'">{{guarantee.status}}</span>
                        <span class="label label-block label-success"
                          *ngIf="guarantee.status === 'Paid' || guarantee.status === 'paid'">{{guarantee.status}}</span>
                        <span class="label label-block label-success"
                          *ngIf="guarantee.status === 'Defaulted' || guarantee.status === 'defaulted'">{{guarantee.status}}</span>
                      </td>
                      <td>{{guarantee.remark}}</td>
                      <td class="text-center">
                        <ul class="icons-list">
                          <li class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                              <i class="icon-menu9"></i>
                            </a>

                            <ul class="dropdown-menu dropdown-menu-right">
                              <li>
                                <a (click)="removeGuarantee(i)">
                                  <i class="icon-cash"></i> Remove</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br>
                <br>
                <div class="row">
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <div class="table-responsive no-border">
                      <table class="table">
                        <tbody>
                          <tr>
                            <th>Equb Value:</th>
                            <td>
                              <h5 class="text-right text-primary text-bold">
                                <!--  {{selectedEkub?.value|number:'1.2-2'}} -->
                                ETB
                              </h5>
                            </td>
                          </tr>
                          <tr>
                            <th>Winner Debt:</th>
                            <td>
                              <h5 class="text-right text-primary text-bold">
                                {{winnerBalance|number:'1.2-2'}}
                                ETB</h5>
                            </td>
                          </tr>
                          <tr>
                            <th>Total Balance:</th>
                            <td class="text-right text-primary">
                              <h5
                                [ngClass]="{'text-danger': totalGuaranteeAmount + winnerBalance < 0, 'text-success': totalGuaranteeAmount + winnerBalance >= 0}"
                                class="text-right text-danger text-bold">{{totalGuaranteeAmount|number:'1.2-2'}} ETB
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="text-right">
              <br>
              <button class="btn bg-slate-800" (click)="saveGuarantee()" type="submit" data-style="slide-right"
                [disabled]="checkValidity()">
                <span>{{guarantees?.length > 0 ? 'Update Guarantee':'Save Guarantee'}}</span>
                <i class="icon-floppy-disk position-right"></i>
              </button>
            </div>











          </div>
          <div class="col-md-6">


            <div class="panel panel-white">
              <!-- <div class="panel-heading">
                    <h4 class="panel-title">Customer Pictures</h4>
                  </div> -->
              <div class="panel-body no-padding-bottom">

                <div class="">
                  <h6>Winner</h6>
                  <hr>
                  <div class="">
                    <div class="thumb thumb-rounded text-center">
                      <img *ngIf="!award?.winner?.user?.data?.avatar" src="assets/img/userm.png" width="100"
                        height="100" class="img-circle img-md" alt="">
                      <img *ngIf="award?.winner?.user?.data?.avatar"
                        [src]="baseUrl+'assets/'+award?.winner?.user?.data?.avatar+'/render'" alt="Winner"
                        class="profileImg img-responsive">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <h6>GUARANTEES</h6>

                  <table class="table datatable-column-search-inputs">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Ref Number</th>
                        <th>Amount Guaranteed</th>
                        <th>Guarantee Date</th>
                        <th>Remark</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody class="table-body">
                      <tr *ngFor="let guarantee of guarantees">
                        <td>
                          <div class="media">
                            <div class="media-left">{{guarantee?.type}}
                            </div>
                          </div>
                        </td>
                        <td>{{guarantee?.ref_number}}</td>
                        <td>{{guarantee?.amount_guaranteed|number:'1.2-2'}} ETB</td>
                        <td>{{guarantee?.created_at | date:short}}</td>
                        <td>{{guarantee?.remark}}</td>
                        <td>
                          <span class="label label-block label-success"
                            *ngIf="guarantee.status === 'Paid' || guarantee.status === 'paid'">{{guarantee.status}}</span>
                          <span class="label label-block label-default"
                            *ngIf="guarantee.status === 'Pending' || guarantee.status === 'pending'">{{guarantee.status}}</span>
                          <span class="label label-block label-primary"
                            *ngIf="guarantee.status === 'Active' || guarantee.status === 'active'">{{guarantee.status}}</span>
                          <span class="label label-block bg-danger"
                            *ngIf="guarantee.status === 'Defaulted' || guarantee.status === 'defaulted'">{{guarantee.status}}</span>
                        </td>
                        <td class="text-center">
                          <ul class="icons-list">
                            <li class="dropdown">
                              <a href="" class="dropdown-toggle" data-toggle="dropdown">
                                <i class="icon-menu9"></i>
                              </a>

                              <ul class="dropdown-menu dropdown-menu-right">
                                <li *ngIf="guarantee.type === 'libre' || guarantee.type === 'carta'">
                                  <a data-toggle="modal" data-target="#libre_carta_modal"
                                    (click)="setSelectedGuarantee(guarantee)">
                                    <i class=" icon-file-pdf"></i>Upload</a>
                                </li>
                                <li class="dropdown-submenu dropdown-submenu-left">
                                  <a href="javascript:void(0);">Change Status</a>
                                  <ul class="dropdown-menu">
                                    <li>
                                      <a (click)="changeGuaranteeStatus(guarantee.id,'pending')">
                                        <i class="icon-shuffle"></i> Pending</a>
                                    </li>
                                    <li>
                                      <a (click)="changeGuaranteeStatus(guarantee.id,'active')">
                                        <i class="icon-shuffle"></i> Active</a>
                                    </li>
                                    <li>
                                      <a (click)="changeGuaranteeStatus(guarantee.id,'paid')">
                                        <i class="icon-shuffle"></i> Paid</a>
                                    </li>
                                    <li>
                                      <a (click)="changeGuaranteeStatus(guarantee.id,'defaulted')">
                                        <i class="icon-shuffle"></i> Defaulted</a>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                      <tr *ngIf="award?.guarantees?.data?.length <= 0">
                        <td class="text-center" colspan="6">No Guarantees Added</td>
                      </tr>
                    </tbody>
                  </table>



                  <div class="row" *ngIf="guarantees?.length > 0">
                    <div class="text-center">

                      <pagination-controls id="obligedGuarantees" (pageChange)="pageChanged(currentPage = $event)">
                      </pagination-controls>

                      <br>
                    </div>

                  </div>




                </div>

                <div *ngIf="award.hasLibre">
                  <h6>Libre</h6>
                  <hr>

                  <div class="well" style="min-height: 250px;">
                    <div class="row">
                      <div class="col-md-3" *ngFor="let libre of award.guarantee_libres">
                        <img [src]="baseUrl+'assets/'+libre.id+'/render'" alt="Vehicle Libre"
                          class="profileImg img-responsive" data-toggle="modal" data-target="#libre_carta_image_modal"
                          (click)="showImageDetail(baseUrl+'assets/'+libre.id+'/render')">
                      </div>
                    </div>
                  </div>

                  <div *ngIf="award.hasCarta">
                    <h6>Ownership Certificate</h6>
                    <hr>
                    <div class="well" style="min-height: 250px;">
                      <div class="row">
                        <div class="col-md-3" *ngFor="let carta of award.guarantee_cartas">
                          <img [src]="baseUrl+'assets/'+carta.id+'/render'" alt="House ownership Certificate"
                            class="profileImg img-responsive" data-toggle="modal" data-target="#libre_carta_image_modal"
                            (click)="showImageDetail(baseUrl+'assets/'+carta.id+'/render')">
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>

                </div>
              </div>

            </div>


          </div>
        </div>

      </div>
    </div>
  </div>

</div>


<!-- <cp-temp></cp-temp> -->




<!-- Vertical form modal -->
<div id="guarantee_modal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Add Guarantee</h5>
      </div>




      <form name="guaranteeForm" [formGroup]="guaranteeForm" novalidate>
        <div class="modal-body">
          <div class="row">

            <div class="col-md-6">
              <div class="form-group required">
                <span class="control-label">Guarantee Type: </span>
                <select name="type" formControlName="type" class="form-control"
                  data-placeholder="Select guarantee type">
                  <option selected disabled>Status:</option>
                  <option value="member">Member</option>
                  <option value="libre">Libre</option>
                  <option value="carta">Carta</option>
                </select>
                <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i> Guarantee Type is required
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <span class="control-label"> Guarantee Ref. Number: </span>
                <input type="text" name="guarantee_ref_number" formControlName="guarantee_ref_number"
                  placeholder="Libre/Carta/Member Code Ref. Number" class="form-control">
                <div class="help-block"
                  *ngIf="guarantee_ref_number.invalid && (guarantee_ref_number.dirty || guarantee_ref_number.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 tx-red position-left"></i> Award guarantee type is required
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-6" *ngIf="type.value == 'member'">
              <label>Guarantee/User</label>
              <ng-select [items]="users" placeholder="search guarantee user" (change)="fetchUserStats()"
                (keyup)="fetchUser($event)" formControlName="guarantee" bindValue="id" bindLabel="text">
              </ng-select>
              <!--  <input type="text" name="guarantee" formControlName="guarantee" placeholder="Guarantee / ekub user"
                class="form-control"> -->
            </div>


            <div class="col-md-6" *ngIf="type.value != 'member'">
              <div class="form-group">
                <span class="control-label"> Guarantee Value: </span>
                <input type="text" name="guarantee_value" formControlName="guarantee_value"
                  placeholder="Guarantee Worth" class="form-control" [required]="type.value != 'member'">
                <div class="help-block"
                  *ngIf="guarantee_value.invalid && (guarantee_value.dirty || guarantee_value.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 tx-red position-left"></i> Guarantee_value is required
                  </p>
                </div>
              </div>
            </div>


            <div class="col-sm-6 required">
              <span class="control-label">Status: </span>
              <select name="status" required formControlName="status" class="form-control"
                data-placeholder="Select ekub status">
                <option selected disabled>Status:</option>
                <option value="pending">Pending</option>
                <option value="active">Active</option>
                <option value="released">Released</option>
              </select>
              <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                <p class="text-danger">
                  <i class="icon-cancel-circle2 position-left"></i>Guarantee status is required.
                </p>
              </div>
            </div>


          </div>


          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" required name="remark" formControlName="remark"
                  placeholder="Additional information . . ."></textarea>
              </div>
            </div>
          </div>


          <div *ngIf="type.value == 'libre'">
            <div class="row">
              <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
                <ngx-dropzone-label>
                  <div>
                    <h6 style="color:gray;" translate>- Drop Guarantee Libre Picture(s) here -</h6>
                  </div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                  [removable]="true" (removed)="onRemove(f)">
                </ngx-dropzone-image-preview>
              </div>

            </div><br>
          </div>

          <div *ngIf="type.value == 'carta'">
            <div class="row">
              <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
                <ngx-dropzone-label>
                  <div>
                    <h6 style="color:gray;" translate>- Drop Guarantee Ownership title (Carta) Picture(s) here -</h6>
                  </div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                  [removable]="true" (removed)="onRemove(f)">
                </ngx-dropzone-image-preview>
              </div>

            </div><br>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="addGuarantee()" [disabled]="guaranteeForm.invalid" data-dismiss="modal"
            class="btn bg-slate-800">Add Guarantee</button>
        </div>
      </form>


    </div>
  </div>
</div>
<!-- /vertical form modal -->


<!-- libre_carta_modal -->
<div id="libre_carta_modal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Add Guarantee</h5>
      </div>

      <div class="modal-body">

        <div *ngIf="selectedGuarantee.type == 'libre'">
          <div class="row">
            <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
              <ngx-dropzone-label>
                <div>
                  <h6 style="color:gray;" translate>- Drop Guarantee Libre Picture here -</h6>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                [removable]="true" (removed)="onRemove(f)">
              </ngx-dropzone-image-preview>
            </div>

          </div><br>
        </div>

        <div *ngIf="selectedGuarantee.type == 'carta'">
          <div class="row">
            <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
              <ngx-dropzone-label>
                <div>
                  <h6 style="color:gray;" translate>- Drop Guarantee Ownership title (Carta) Picture here -</h6>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                [removable]="true" (removed)="onRemove(f)">
              </ngx-dropzone-image-preview>
            </div>

          </div><br>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
        <button (click)="uploadFile(selectedGuarantee)" [disabled]="files?.length<=0" class="btn bg-slate-800">Upload
          Picture</button>
      </div>

    </div>
  </div>
</div>
<!-- /libre_carta_modal -->

<!-- libre_carta_image_modal -->
<div id="libre_carta_image_modal" class="modal fade" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-body">


        <img [src]="selectedGuaranteeImage" class="img-responsive" alt="Guarantee Image">

      </div>

    </div>
  </div>
</div>
<!-- /libre_carta_image_modal -->